import { Box, Flex, Heading } from '@chakra-ui/react';
import React from 'react';

import { CreditFacilitySelect } from 'packages/credit-facility/ui/CreditFacilitySelect';
import { SingleEntityDrawer as FundingRequestEventLogSingleEntityDrawer } from '~/core/routes/funding-requests/EntityEventLogDrawers';

export const FundingRequestsViewTemplate = ({
  children,
  isCreditFacilitySelectDisabled,
  fundingRequestId,
}: {
  isCreditFacilitySelectDisabled: boolean;
  children: React.ReactNode;
  fundingRequestId: string;
}) => {
  return (
    <>
      <Flex justify="space-between">
        <Heading as="h2">Funding Request</Heading>
        <Flex gap="0.5rem">
          <CreditFacilitySelect isDisabled={isCreditFacilitySelectDisabled} />
          <FundingRequestEventLogSingleEntityDrawer
            entityId={fundingRequestId}
          />
        </Flex>
      </Flex>
      <Box mt="25px" padding="10px">
        {children}
      </Box>
    </>
  );
};
